import React, { MutableRefObject } from 'react';
import { Grid, useMediaQuery, useTheme } from '@material-ui/core';

import { StudioControlStyles } from '../styles';
import CameraSettingsPanel from './CameraSettingsPanel';
import CameraControlsMobile from './CameraControlsMobile';
import CameraControlsDesktop from './CameraControlsDesktop';

type Props = {
  refPrompter: MutableRefObject<HTMLDivElement | null>;
  bottomViewContainerId: string;
};

const CameraControls = (
  { refPrompter, bottomViewContainerId }: Props,
) => {
  const classes = StudioControlStyles();
  const theme = useTheme();
  const compact = useMediaQuery(theme.breakpoints.down('xs'));

  return (
    <>
      <Grid container className={classes.root} alignItems="center">
        {compact
          ? (
            <CameraControlsMobile
              refPrompter={refPrompter}
            />
          )
          : (
            <CameraControlsDesktop
              refPrompter={refPrompter}
            />
          )}
      </Grid>
      <CameraSettingsPanel
        bottomViewContainerId={bottomViewContainerId}
      />
    </>
  );
};

export default CameraControls;
